import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import type { PatientDetails } from "@/core/types";
import { patientKeys } from "@/features/patient/api/keyFactory";
import type { UpdatePatientStatusResponse } from "@/api/(requests)/providerTyped";

import {
  updatePatientStatus,
  type UpdatePatientStatusVariables,
} from "../queryFunctions/updatePatientStatus";

export function useUpdatePatientStatus({
  onSuccess,
  ...options
}: UseMutationOptions<UpdatePatientStatusResponse, unknown, UpdatePatientStatusVariables>) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePatientStatus,
    ...options,
    onSuccess: async (data, variables, context) => {
      queryClient.setQueryData<PatientDetails>(
        patientKeys.details(variables.patientId),
        (oldData) =>
          oldData
            ? { ...oldData, previous_status: data.previous_status, status: variables.status }
            : oldData,
      );

      await queryClient.invalidateQueries({
        queryKey: patientKeys.details(variables.patientId),
      });

      // Caller-supplied callback
      onSuccess?.(data, variables, context);
    },
  });
}
